import styled from 'styled-components';
import eyeGray from '../../assets/img/eye.svg'
import eyeWhite from '../../assets/img/eye.png'

const EyeGray = styled.img.attrs({
    src: eyeGray,
    alt: 'eye',
}) `
    width: 15px;
    height: 10px;
    margin-right: 8px;
`

const EyeWhite = styled.img.attrs({
    src: eyeWhite,
    alt: 'eye',
}) `
    width: 13px;
    height: 10px;
    margin-right: 8px;
    transition: all .3s ease;    
`
export {EyeGray,EyeWhite};


// WEBPACK FOOTER //
// ./src/Info/Recent/Eye.js